import Accordion from "../@tix02/component/Accordion";
import { Event } from '../@tix02/utility/event';
import { select } from '../@tix02/utility/dom';

export default (elements, params = {}) => {
	
	const _elements = () => {
		if( typeof(elements) === 'string' ) {
			return select(elements).all();
		}
		if( elements instanceof HTMLElement ) {
			return [elements];
		}
		return elements;
	};
	
	const _init = () => {
		const accs = _elements(elements);
		accs.forEach(el => {
			new Accordion(el, params);
		});
	};
	
	document.addEventListener(Event.PAGE_LOAD, _init);
	_init();
};